export default function AssignEmployeeModal({
  assigningClaim,
  employees,
  loadingEmployees,
  selectedEmployee,
  setSelectedEmployee,
  onAssign,
  onClose,
}) {
  // 🛡️ SAFETY GUARD (MANDATORY)
  if (!assigningClaim) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">
      <div className="bg-white p-4 rounded-xl w-full max-w-md space-y-3">

        <h3 className="font-semibold">Assign Employee</h3>

        <p className="text-sm text-slate-600">
          Claim ID: <strong>{assigningClaim.id}</strong>
        </p>

        {/* Employee Dropdown */}
        {loadingEmployees ? (
          <p className="text-sm text-slate-500">Loading employees…</p>
        ) : (
          <select
            className="border w-full px-2 py-1 rounded text-sm"
            value={selectedEmployee}
            onChange={(e) => setSelectedEmployee(Number(e.target.value))}
          >
            <option value="">Select Employee</option>
            {employees.map((emp) => (
              <option key={emp.id} value={emp.id}>
                {emp.first_name} {emp.last_name}
              </option>
            ))}
          </select>
        )}

        {/* Actions */}
        <div className="flex justify-end gap-2 pt-2">
          <button
            onClick={onClose}
            className="px-3 py-1 text-sm border rounded"
          >
            Cancel
          </button>

          <button
            onClick={onAssign}
            disabled={!selectedEmployee}
            className="bg-blue-600 disabled:bg-blue-300 text-white px-3 py-1 text-sm rounded"
          >
            Assign
          </button>
        </div>

      </div>
    </div>
  );
}
